package com.damda.design_system.ui.views.web

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundSize
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.textDecoration
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainPage(hedgehogView: @Composable () -> Unit) {
    Div(attrs = {
        style {
            height(100.vh - 72.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
        }
    }) {
        Div(attrs = {
            style {
                height(100.percent)
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                backgroundColor(Color.white)
            }
        }) {
            LeftContent()
            RightContent(hedgehogView)
        }
    }
}

@Composable
fun LeftContent() {
    Div(
        attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.Center) // 수평 가운데 정렬
                justifyContent(JustifyContent.SpaceBetween)
                height(100.vh - 72.px)
            }
        }
    ) {
        Div(attrs = {
            style {
                flex(1)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                padding(48.px)
                backgroundImage("url('texture_background.jpg')")  // 배경 이미지 설정
                backgroundSize("cover")  // 배경 이미지 크기 설정
                backgroundPosition("center")  // 배경 이미지 위치 설정
            }
        }) {
            H1(attrs = {
                style {
                    fontSize(3.em)
                    fontWeight("bold")
                }
            }) {
                Text("핀쵸와 ")
                Span(attrs = {
                    style {
                        color(Color("#ea8c34"))
                    }
                }) { Text("와인") }
                Text(" 모든 것을 즐길 수 있는\nHEDGEHOG\uD83C\uDF77")
            }

            P(attrs = {
                style {
                    fontSize(1.em)
                }
            }) {
                Text("을지로의 루프탑 와인바 HADGEHOG! 멋진 야경과 함께 즐기는 와인 한 잔의 여유를 느껴보세요. \uD83E\uDD42✨")
            }
            Div (attrs = {
                style {
                    height(24.px)
                }
            })
            ActionButtons()
        }
    }
}

@Composable
fun ActionButtons() {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            gap(16.px)
        }
    }) {
        Button(attrs = {
            style {
                padding(16.px, 32.px)
                backgroundColor(Color("#2DB400"))
                color(Color.white)
                border(0.px)
                borderRadius(4.px)
                cursor("pointer")
                fontSize(1.em)
            }
        }) {
            Div (
                attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        height(32.px)  // 부모 Div의 높이를 100%로 설정하여 화면 전체를 차지하도록 함
                        gap(16.px)
                        flexDirection(FlexDirection.Row)  // 세로 방향 정렬
                        alignItems(AlignItems.Center)  // 가로 중앙 정렬
                        justifyContent(JustifyContent.Center)  // 세로 중앙 정렬
                    }
                }
            ){
                Img(src = "ic_naver_white.png", attrs = {
                    style {
                        width(24.px)
                        height(24.px)
                    }
                })
                Div(attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        alignItems(AlignItems.Center)  // 수직 중앙 정렬
                    }
                }) {
                    A("https://naver.me/xbA4ntAF", attrs = {
                        style {
                            color(Color("inherit"))  // 부모 요소의 폰트 색상 상속
                            textDecoration("none")  // 밑줄 제거
                        }
                    }){
                        Text("네이버 예약")
                    }
                }

            }
        }

    }
}

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun RightContent(hedgehogView: @Composable () -> Unit) {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Start)
            justifyContent(JustifyContent.Center) // 수평 및 수직 가운데 정렬
            width(50.percent)
            height(100.vh - 72.px)
            paddingTop(48.px)
            position(Position.Relative)  // 부모 Div의 position을 relative로 설정
            overflow("hidden")  // 자식 요소가 부모 범위를 벗어나지 않도록 설정
        }
    }) {
        Div(attrs = {
            style {
                position(Position.Absolute)  // 배경 Div의 position을 absolute로 설정
                top(0.px)
                left(0.px)
                width(100.percent)
                height(100.percent)
                backgroundImage("url('hedgehog_background.jpg')")  // 배경 이미지 설정
                backgroundSize("cover")  // 배경 이미지 크기 설정
                backgroundPosition("center")  // 배경 이미지 위치 설정
            }
        })
        // 검정색 오버레이 Div
        Div(attrs = {
            style {
                position(Position.Absolute)  // 오버레이 Div의 position을 absolute로 설정
                top(0.px)
                left(0.px)
                width(100.percent)
                height(100.percent)
                backgroundColor(rgba(0, 0, 0, 0.3))  // 반투명 검정색 오버레이
            }
        })
        // Cards on top of the background image
        Div(attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(16.px)
                alignItems(AlignItems.Start) // 수평 가운데 정렬
                justifyContent(JustifyContent.Center) // 수직 가운데 정렬
                position(Position.Relative)  // 자식 Div의 position을 relative로 설정
            }
        }) {
            hedgehogView()
        }
    }
}